import { combineReducers } from 'redux'

import administracao from './store/administracao'
import cargo from './store/cargo'
import modalidade from './store/modalidade'
import informacoesInstitucionais from './store/informacoesInstitucionais'
import faleConosco from './store/faleConosco'
import destaque from './store/destaque'
import buscarPesquisa from './store/buscarPesquisa'
import administracaoDiretaIndiretaInativa from './store/administracaoDiretaIndiretaInativa'
import indicador from './store/indicador'
import predio from './store/predio'
import unidade from './store/unidade'

const entidades = combineReducers({
    administracao,
    cargo,
    modalidade,
    informacoesInstitucionais,
    faleConosco,
    destaque,
    buscarPesquisa,
    administracaoDiretaIndiretaInativa,
    indicador,
    predio,
    unidade,
})
export default combineReducers({ entidades })
